import PropTypes from 'prop-types'

function Policyholder({ person, isPrimary }) {
  return (
    <div className="space-y-1 text-gray-600">
      <div className="flex items-center text-black">
        <p className="font-semibold">
          {person.name.full
            ? person.name.full
            : `${person.name.first} ${person.name.last}`}{' '}
          {isPrimary && (
            <small className="font-medium text-gray-500">(primary)</small>
          )}
        </p>
      </div>

      {person.address && (
        <div className="text-sm">
          <p>{person.address.line1}</p>
          <p>{person.address.line2}</p>
          <p>
            {person.address.city}, {person.address.state}{' '}
            {person.address.postal_code}
          </p>
        </div>
      )}
      {person.phone_numbers.length > 0 && (
        <div className="text-sm">
          {person.phone_numbers.map((num) => (
            <p key={num.number}>{num.number}</p>
          ))}
        </div>
      )}
      {person.email_addresses.length > 0 && (
        <div className="text-sm">
          {person.email_addresses.map((email) => (
            <div key={email.address}>
              <p>{email.address}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

// Define prop types
Policyholder.propTypes = {
  person: PropTypes.object,
  isPrimary: PropTypes.bool,
}

export default Policyholder
